import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import {
  AddContactGroupByEmailButton,
  AddContactGroupByEmailTrigger,
  ContactList,
  CustomerContactGroupList,
  LocationList,
} from 'contacts/components';
import { ContactGroupType, ContactListViewTab } from 'contacts/enums';
import { PageLayout, PageTitle, Tabs } from 'core/components';
import { SelectionCountProvider } from 'core/states';

export const CustomerContactListPage = () => {
  const [searchParams] = useSearchParams();

  const { t } = useTranslation();

  const buttons = useMemo(() => {
    return [
      <AddContactGroupByEmailButton
        contactGroupType={ContactGroupType.CUSTOMER}
        key="addContactGroupByEmailButton"
        defaultOpen={searchParams.get('trigger') === AddContactGroupByEmailTrigger.ADD_CUSTOMER}
      />,
    ];
  }, [searchParams]);

  const tabs = useMemo(() => {
    return [
      {
        value: ContactListViewTab.CONTACTS,
        label: t('labelViewByContacts'),
        content: <ContactList groupType={ContactGroupType.CUSTOMER} />,
      },
      {
        value: ContactListViewTab.LOCATIONS,
        label: t('labelViewByLocations'),
        content: <LocationList contactGroupType={ContactGroupType.CUSTOMER} />,
      },
      {
        value: ContactListViewTab.COMPANIES,
        label: t('labelViewByCompanies'),
        content: <CustomerContactGroupList />,
      },
    ];
  }, [t]);

  return (
    <PageLayout title={t('titleCustomerContacts')}>
      <SelectionCountProvider>
        <PageTitle title={t('titleCustomers')} buttons={buttons} />

        <Tabs
          tabs={tabs}
          ariaLabel="customerContactListTabs"
          defaultTab={ContactListViewTab.COMPANIES}
        />
      </SelectionCountProvider>
    </PageLayout>
  );
};
